import type { Article } from './types';

export const articles: Article[] = [
  {
    id: 'article-1',
    slug: 'bian-jie-gan-de-zhong-yao-xing',
    title: '婚姻边界感：为什么它是幸福婚姻的基石',
    excerpt: '边界感不是冷漠，而是对婚姻的尊重。本文深入剖析婚姻中边界感的真正含义，以及它如何成为维系夫妻信任与安全感的底层逻辑。',
    content: `<p>在婚姻生活中，我们常常听到"边界感"这个词，但很少有人真正理解它的含义。边界感不是冷漠，不是疏远，而是对婚姻的一种深刻尊重。</p>
<h2>什么是婚姻边界感？</h2>
<p>婚姻边界感，简单来说，就是夫妻双方在婚姻关系中，对彼此行为、情感和社交范围的一种默契约定。它不是写在纸上的规则，而是刻在心上的分寸。</p>
<p>很多已婚男性会有一个困惑：妻子的朋友，我该怎么相处？太热情了怕引起误会，太冷淡了又显得不礼貌。这恰恰就是边界感需要发挥作用的地方。</p>
<h2>边界感的三个层次</h2>
<p><strong>第一层：物理边界。</strong>包括肢体接触、独处空间、私人物品的使用等。与妻子的闺蜜相处时，保持适当的物理距离是最基本的尊重。比如，避免在不必要的情况下单独共处一室，避免过度的肢体接触。</p>
<p><strong>第二层：情感边界。</strong>这可能是最难把握的一层。你可以关心妻子的朋友，但关心的程度和方式需要有限度。不要成为她倾诉情感问题的首选对象，那是她自己的朋友或伴侣应该扮演的角色。</p>
<p><strong>第三层：信息边界。</strong>夫妻之间有太多只属于两个人的秘密和私密话题。这些内容不应该在任何情况下透露给第三人，哪怕那个人是妻子最好的朋友。</p>
<h2>为什么边界感如此重要？</h2>
<p>研究表明，婚姻满意度高的夫妻，往往在社交边界上有清晰的共识。边界感带来的好处包括：增强夫妻间的信任感、减少不必要的猜疑和摩擦、让双方的社交圈更加健康有序。</p>
<h2>如何建立健康的边界感？</h2>
<p>首先，和妻子开诚布公地讨论这个问题。每个人对边界的理解不同，你认为是正常的行为，妻子可能觉得越界了。沟通是建立边界的第一步。</p>
<p>其次，在日常生活中践行约定。当你和妻子的朋友互动时，时刻记得你是一个已婚男人的身份。这个身份不是束缚，而是一种荣耀和责任。</p>
<p>最后，当边界被触碰时，温和但坚定地表达自己的立场。不卑不亢，既维护了婚姻的尊严，也保持了人际关系的和谐。</p>`,
    category: '婚姻边界感',
    categorySlug: 'hun-yin-bian-jie-gan',
    author: '李心安',
    date: '2025-12-15',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20illustration%20of%20a%20couple%20sitting%20comfortably%20in%20a%20bright%20living%20room%20with%20soft%20sunlight%20streaming%20through%20large%20windows%2C%20conveying%20trust%20and%20emotional%20safety%2C%20clean%20lines%2C%20gentle%20beige%20and%20cream%20tones%2C%20editorial%20style%2C%20warm%20atmosphere&width=800&height=500&seq=article-boundary-01&orientation=landscape',
    tags: ['边界感', '婚姻基础', '夫妻信任'],
    readTime: 8
  },
  {
    id: 'article-2',
    slug: 'ru-he-yu-qi-zi-gui-mi-xiang-chu',
    title: '如何与妻子的闺蜜相处：五个实用原则',
    excerpt: '妻子的闺蜜是婚姻中绕不开的存在。掌握这五个原则，让你既能维持友好关系，又不会触碰婚姻的红线。',
    content: `<p>妻子的闺蜜——这个话题在很多已婚男性的聚会上总会引发一阵意味深长的沉默。确实，她们是婚姻生活中一个微妙而真实的存在。</p>
<h2>原则一：始终以"我们"而非"我"的身份出现</h2>
<p>当你和妻子的闺蜜互动时，无论是微信聊天还是线下聚会，要始终保持"夫妻共同体"的意识。说话时多用"我和XX（妻子名字）都觉得"，而不是"我觉得"。这种语言习惯会在潜意识中提醒所有人——你是一个已婚男人，你的妻子始终在你身边。</p>
<h2>原则二：避免单独相处的情境</h2>
<p>这不是不信任，而是对婚姻的敬畏。如果妻子的闺蜜需要帮忙，尽量在妻子知情且同意的情况下进行，或者带上妻子一起。实在需要单独见面，选择公共场所，并提前告知妻子。</p>
<h2>原则三：信息透明是最大的安全感</h2>
<p>妻子闺蜜发来的微信，可以让妻子看到。如果闺蜜跟你说了什么，及时跟妻子同步。这种透明度不是被监视，而是主动给予的安全感。很多婚姻危机，都是从"我以为没什么大不了"开始的。</p>
<h2>原则四：保持适当的情感距离</h2>
<p>你可以关心她，但你不是她的情感支柱。如果她向你倾诉感情问题，你的角色是倾听和适度建议，而不是深度介入。最好的方式是引导她去找你的妻子——她的真正朋友——进行交流。</p>
<h2>原则五：让妻子始终感到她是第一优先级</h2>
<p>在任何社交场合，你对待妻子的方式应该明显区别于对待她朋友的方式。妻子应该能清楚地感受到：在你心中，她和所有人都不一样。这不是表演，而是发自内心的优先级排序。</p>`,
    category: '异性友谊处理',
    categorySlug: 'yi-xing-you-yi-chu-li',
    author: '王明远',
    date: '2025-11-28',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20three%20people%20having%20a%20friendly%20conversation%20at%20a%20bright%20cafe%20with%20warm%20lighting%2C%20one%20person%20slightly%20apart%20maintaining%20respectful%20distance%2C%20soft%20neutral%20tones%2C%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=article-friend-02&orientation=landscape',
    tags: ['闺蜜相处', '社交原则', '婚姻智慧'],
    readTime: 6
  },
  {
    id: 'article-3',
    slug: 'ju-hui-chang-he-de-de-ti-ju-zhi',
    title: '聚会场合的得体举止：已婚男性的社交礼仪',
    excerpt: '在朋友聚会、家庭聚餐等场合，已婚男性如何把握与妻子朋友互动的分寸？本文提供场景化的行为指南。',
    content: `<p>聚会是最容易暴露社交边界问题的地方。几杯酒下肚，气氛变得轻松，有些平时注意不到的小细节就可能被放大。</p>
<h2>酒桌上的分寸</h2>
<p>酒精是社交边界的头号敌人。在聚会中，控制饮酒量是第一要务。微醺可以活跃气氛，但醉酒就可能让你说出或做出不该做的事情。如果你酒量一般，建议以茶代酒或用低度酒替代。</p>
<p>当妻子的朋友向你敬酒时，回敬即可，不要主动频繁敬酒。更不要在酒后单独找她聊天，这种行为无论多么清白，在外人眼中都容易产生误解。</p>
<h2>话题选择有讲究</h2>
<p>和妻子的朋友聊天时，安全话题包括：工作近况、共同爱好、社会热点。需要回避的话题包括：婚姻抱怨、情感状态、对妻子的负面评价。即使你和妻子之间有矛盾，也不应该在第三方面前讨论。</p>
<p>如果对方主动聊起私人话题，礼貌地将话题引导到更中性的方向，比如"这事你和我老婆聊可能更好，她比我懂"。这既保持了友好，也划清了边界。</p>
<h2>肢体语言的学问</h2>
<p>聚会中的肢体语言比言语更容易被忽视。注意保持适当的个人空间，避免拍肩、摸头、搂腰等动作。合照时，选择集体照而非二人合照。这些细节累积起来，就是你在妻子心中可靠形象的基石。</p>
<h2>离场时的注意事项</h2>
<p>聚会结束时，如果需要送人回家，优先安排同性朋友同行，或让妻子来决定送人的方案。如果必须单独送妻子的朋友，主动开启行车记录仪，并在到达后第一时间告知妻子。</p>`,
    category: '社交场合行为',
    categorySlug: 'she-jiao-chang-he-xing-wei',
    author: '陈志远',
    date: '2025-11-15',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20illustration%20of%20a%20dinner%20party%20scene%20with%20people%20seated%20around%20a%20table%2C%20soft%20ambient%20lighting%2C%20elegant%20and%20respectful%20atmosphere%2C%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=article-social-03&orientation=landscape',
    tags: ['聚会礼仪', '社交分寸', '肢体语言'],
    readTime: 7
  },
  {
    id: 'article-4',
    slug: 'qi-zi-chi-cu-zen-me-ban',
    title: '妻子吃醋了怎么办？化解社交误会的高情商沟通法',
    excerpt: '当妻子因为你与她的朋友互动产生醋意时，错误的应对方式会让事情更糟。学会这些沟通技巧，把危机变成增进感情的机会。',
    content: `<p>"你是不是对她太好了？"当妻子问出这句话时，很多丈夫的第一反应是辩解："你想多了！"然而，这恰恰是最糟糕的回应。</p>
<h2>先接纳情绪，再解释事实</h2>
<p>妻子吃醋时，她需要的不是逻辑解释，而是情感确认。你可以说："我理解你的感受，如果换作是我看到你和别的男人走得太近，我也会不舒服。谢谢你愿意跟我说，这让我知道你很在乎我们的关系。"</p>
<p>这种回应传达了三个信息：我听到了你、我理解你、我珍视你的感受。当妻子的情绪被接纳后，她才有心理空间去接受事实层面的解释。</p>
<h2>用行动而非言语来证明</h2>
<p>解释之后，行动比言语更有说服力。如果你之前和她的某个朋友互动较多，可以主动调整频率。不是突然切断联系（那样反而显得心虚），而是自然地减少不必要的互动，让妻子感受到你的调整。</p>
<p>同时，多做一些让妻子感到特别的事情。在朋友圈发一张你们的合照，在朋友聚会时多牵她的手，在聊天时自然地提到"我老婆说"。这些小动作都在无声地告诉她：放心，你永远是第一位的。</p>
<h2>避免的雷区</h2>
<p>千万不要说："她只是朋友，你至于吗？"这种否定妻子感受的话是婚姻中的毒药。也不要反过来指责妻子"太小气"或"不信任我"，这只会让矛盾升级。</p>
<p>更不要拿妻子的朋友和妻子做比较，哪怕是正面的比较（比如"你看人家多善解人意"），这话一出口就是一场风暴。</p>
<h2>把这件事变成关系升级的契机</h2>
<p>每一次吃醋事件的妥善处理，都是婚姻关系的一次加固。当你们一起跨过这个坎，彼此的信任会更深，妻子下一次也会更愿意跟你直接表达感受，而不是憋在心里。</p>`,
    category: '夫妻沟通技巧',
    categorySlug: 'fu-qi-gou-tong-ji-qiao',
    author: '李心安',
    date: '2025-10-20',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20a%20couple%20having%20a%20heartfelt%20conversation%20on%20a%20cozy%20sofa%20with%20warm%20afternoon%20light%2C%20emotionally%20connected%2C%20soft%20neutral%20and%20cream%20tones%2C%20editorial%20style%2C%20gentle%20atmosphere&width=800&height=500&seq=article-jealous-04&orientation=landscape',
    tags: ['吃醋', '高情商', '夫妻沟通'],
    readTime: 7
  },
  {
    id: 'article-5',
    slug: 'xin-li-xue-jiao-du-kan-bian-jie',
    title: '心理学视角：为什么边界模糊会导致婚姻危机',
    excerpt: '从心理学角度解析"滑坡效应"——微小的边界模糊如何一步步演变成婚姻危机，以及如何从根源上预防。',
    content: `<p>在婚姻咨询中，有一个经典案例：丈夫和妻子的闺蜜因为"正常社交"越走越近，最终导致了两个家庭的破碎。回溯整个过程，没有人是故意的，每一次互动单独看都"没什么大不了的"。这就是心理学的"滑坡效应"。</p>
<h2>什么是滑坡效应？</h2>
<p>滑坡效应（Slippery Slope）指的是，人们在做出一系列小决定时，每个单独看都不严重，但累积起来的后果却可能是灾难性的。在婚姻社交边界中，这个过程可能是：</p>
<p>第一次，你在微信上多聊了几句→ 第二次，你们单独吃了顿饭→ 第三次，你帮她解决了一个私人问题→ 第四次，你开始跟她分享你和妻子的矛盾→ 不知不觉中，一条情感的岔路已经形成。</p>
<h2>为什么我们容易"滑"下去？</h2>
<p>心理学研究发现，人类有一种"自我合理化"的倾向。当我们做了一件可能不太妥当的事情时，大脑会自动寻找理由来证明这件事没有问题："我们是清白的""我只是在帮忙""妻子知道了也会理解的"。</p>
<p>这种自我合理化让我们在下一次面对类似情境时，更容易越过边界，因为上一次的"合理化"已经降低了我们的警觉性。</p>
<h2>如何建立"边界预警系统"？</h2>
<p>心理学家建议设立几个"预警信号"：当你发现自己在刻意对妻子隐瞒和某人的互动时；当你期待和某人独处时；当你开始和某人分享你不对妻子说的事情时。这三个信号中的任何一个出现，都意味着你需要立刻调整自己的行为。</p>
<h2>预防永远比补救容易</h2>
<p>婚姻危机一旦形成，修复的成本是巨大的。与其等着出了问题再解决，不如从一开始就建立清晰的边界意识。这不仅是对婚姻的保护，也是对自己和伴侣的尊重。</p>`,
    category: '心理与情感',
    categorySlug: 'xin-li-yu-qing-gan',
    author: '张思齐',
    date: '2025-09-18',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20a%20person%20standing%20at%20the%20edge%20of%20a%20gentle%20slope%20looking%20ahead%20thoughtfully%2C%20symbolizing%20slippery%20slope%20concept%2C%20soft%20warm%20beige%20and%20cream%20tones%2C%20clean%20editorial%20style&width=800&height=500&seq=article-psych-05&orientation=landscape',
    tags: ['心理学', '滑坡效应', '婚姻危机'],
    readTime: 8
  },
  {
    id: 'article-6',
    slug: 'zhen-shi-an-li-yi-wai-de-qing-gan',
    title: '真实案例：一场意外的情感越界，我如何挽回了婚姻',
    excerpt: '一位已婚男性匿名分享自己差点越界的亲身经历，以及他是如何悬崖勒马、重建妻子信任的心路历程。',
    content: `<p>（以下内容来自读者投稿，已做匿名处理）</p>
<p>结婚七年，我一直认为自己是个好丈夫。直到那一天，我发现自己差点毁掉这一切。</p>
<h2>一切从"帮忙"开始</h2>
<p>妻子的闺蜜小林（化名）离婚了，情绪很低落。妻子让我有空时开导开导她，因为我是做心理咨询相关工作的。起初，我只是以专业身份给她一些建议。但渐渐地，我们的聊天频率越来越高，话题也越来越私人。</p>
<p>我开始期待她的消息，会在工作时走神想她今天心情好不好。我知道这不对，但每次都在心里告诉自己："我只是在帮忙而已。"</p>
<h2>那个让我惊醒的瞬间</h2>
<p>有一天晚上，妻子拿着我的手机翻看我和小林的聊天记录。她什么也没说，只是把手机放下，默默去了另一个房间。我追过去，看到她坐在床边，眼泪无声地往下掉。</p>
<p>那一刻，我像被人泼了一盆冰水。我意识到，那些我认为"没什么"的聊天，在妻子眼中每一句都是刀。我没有出轨，但我的心已经走远了。这对妻子来说，和出轨没什么区别。</p>
<h2>我是怎么走回来的</h2>
<p>第二天，我主动约妻子进行了一次长谈。我没有辩解，没有说"你想多了"，而是真诚地承认了我情感上的越界。我告诉她，我意识到了自己的问题，我愿意做出改变。</p>
<p>具体措施包括：我主动减少了和小林的聊天频率，所有必要的交流都放在三人群里；我把手机密码告诉了妻子，让她可以随时查看；我还约了一位婚姻咨询师，和妻子一起进行了几次辅导。</p>
<h2>给所有已婚男性的忠告</h2>
<p>这件事已经过去一年多了，我和妻子的关系现在比之前更好。但这段经历让我明白了一个道理：婚姻的边界就像悬崖边的护栏，你不需要真的掉下去才知道它的重要性。一旦你开始试探护栏的牢固度，你就已经在危险之中了。</p>`,
    category: '真实案例分享',
    categorySlug: 'zhen-shi-an-li-fen-xiang',
    author: '匿名读者',
    date: '2025-08-05',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20a%20person%20sitting%20alone%20in%20a%20dimly%20lit%20room%20contemplating%20with%20a%20sense%20of%20regret%20and%20reflection%2C%20soft%20warm%20beige%20and%20grey%20tones%2C%20editorial%20style%2C%20emotional%20depth&width=800&height=500&seq=article-case-06&orientation=landscape',
    tags: ['真实案例', '情感越界', '婚姻挽回'],
    readTime: 7
  },
  {
    id: 'article-7',
    slug: 'fu-qi-gong-tong-she-jiao-quan',
    title: '建立夫妻共同社交圈：让妻子放心的高级策略',
    excerpt: '与其被动地应对社交边界问题，不如主动建立一个健康的夫妻共同社交圈。本文分享如何与妻子一起打造让双方都舒适的社交生态。',
    content: `<p>聪明的已婚男性不会把"如何与妻子的朋友相处"当作一个需要单独面对的问题，而是把它融入到一个更大的框架中：建立夫妻共同社交圈。</p>
<h2>什么是夫妻共同社交圈？</h2>
<p>夫妻共同社交圈不是要求你们所有朋友都一样，而是指你们有一个共享的社交基础——在这个基础上，双方都感到安全、被尊重、被重视。妻子的朋友可以是你们的共同朋友，而不只是"她的朋友"或"潜在的问题"。</p>
<h2>三步建立共同社交圈</h2>
<p><strong>第一步：创造共同回忆。</strong>定期组织夫妻双人参与的活动，比如一起做饭、短途旅行、桌游之夜。邀请妻子的朋友和她们的伴侣参加，将单独互动转化为群体互动。</p>
<p><strong>第二步：建立"我们"的品牌形象。</strong>在社交圈中，让大家把你们看作一个整体。你可以和妻子约定一些只有你们知道的小暗号、小习惯，在社交场合自然地展现出来。这种默契本身就是最有力的边界信号。</p>
<p><strong>第三步：定期社交"对账"。</strong>每个月找一个时间，和妻子聊聊最近的社交情况。有没有让彼此不舒服的地方？有没有需要调整的边界？这种定期的沟通能让小问题在变成大问题之前就被解决。</p>
<h2>为什么这个策略有效？</h2>
<p>传统思路是"防"——防止越界、防止误会、防止妻子不高兴。但"防"永远是被动的。建立共同社交圈是"建"——主动构建一个让所有人都舒适的环境。在这个环境中，边界不是限制，而是保护。</p>`,
    category: '夫妻沟通技巧',
    categorySlug: 'fu-qi-gou-tong-ji-qiao',
    author: '王明远',
    date: '2025-07-22',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20multiple%20couples%20enjoying%20a%20garden%20party%20together%20in%20warm%20afternoon%20light%2C%20harmonious%20social%20atmosphere%2C%20soft%20beige%20and%20cream%20tones%2C%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=article-couple-circle-07&orientation=landscape',
    tags: ['社交圈', '夫妻关系', '社交策略'],
    readTime: 6
  },
  {
    id: 'article-8',
    slug: 'nan-xing-shi-jiao-bian-jie-si-kao',
    title: '男性视角：承认边界的存在，是一种成熟',
    excerpt: '很多男性觉得"谈边界就是心虚"，但真正成熟的男人才懂得：正视边界的男人，反而更有魅力。',
    content: `<p>在一次男性成长小组的讨论中，一位结婚十五年的男士说了一句话，让全场陷入沉思："年轻的时候，我觉得边界是对我的束缚。现在我才明白，边界是对我的保护。"</p>
<h2>"我又不会做什么，为什么要注意边界？"</h2>
<p>这是很多男性在面对边界话题时的本能反应。这个反应背后有一个隐含的逻辑：只要我没有实质性的越轨行为，其他一切都是多虑。但这个逻辑忽略了两个关键问题。</p>
<p>第一，婚姻中的信任不是靠"没发生什么"来维持的。妻子需要的不是结果上的清白，而是过程中的安全感。一个从不靠近悬崖的人，比一个"站在悬崖边上但没有跳下去"的人更让人放心。</p>
<p>第二，人的情感是流动的。你今天确信自己不会越界，不代表在特殊情境下——酒精、情感低谷、婚姻疲惫——你依然能把持得住。边界意识不是否认自己的定力，而是承认自己的人性。</p>
<h2>成熟男人的边界观</h2>
<p>真正成熟的男人，会主动和妻子探讨边界问题。他不是因为心虚，而是因为他在乎这段关系，愿意为它付出额外的努力。这种主动，在妻子眼中不是软弱，而是担当。</p>
<p>成熟的男人也明白，边界不是单向的。他也希望妻子和异性保持适当的距离，但他会用同样的标准要求自己。这种对等性让边界从"控制"变成了"协议"。</p>
<h2>边界感是一种高级魅力</h2>
<p>有趣的是，一个边界清晰的男人，往往在社交中更受欢迎。因为他的行为可预测、可信赖，和他相处让人感到安全。妻子的朋友也会因为他的分寸感而更加尊重他——以及他的婚姻。</p>`,
    category: '婚姻边界感',
    categorySlug: 'hun-yin-bian-jie-gan',
    author: '陈志远',
    date: '2025-06-10',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20a%20confident%20man%20standing%20calmly%20with%20a%20sense%20of%20inner%20peace%2C%20warm%20natural%20light%20from%20a%20window%2C%20symbolizing%20maturity%20and%20self%20awareness%2C%20soft%20beige%20tones%2C%20editorial%20style&width=800&height=500&seq=article-mature-08&orientation=landscape',
    tags: ['男性视角', '成熟', '边界意识'],
    readTime: 6
  },
  {
    id: 'article-9',
    slug: 'qi-zi-gui-mi-xiang-ni-biao-bai',
    title: '当妻子的闺蜜向你表白：如何体面地化解危机',
    excerpt: '这是一个极端但并非罕见的情况。如果你遇到妻子的闺蜜对你产生了好感甚至表白，怎样处理才能既保护婚姻又不伤害所有人的体面？',
    content: `<p>这是每个已婚男性都不希望遇到、但确实可能发生的情况。处理得好，危机可以变成婚姻的加固剂；处理得不好，三个人的关系都可能被摧毁。</p>
<h2>第一步：不要惊慌，但必须严肃</h2>
<p>当妻子的闺蜜向你表白时，你的第一反应至关重要。不要笑，不要把这件事当作玩笑——那是对对方情感的轻视，也不能把问题解决。也不要慌张失措，那会传递出"我也有同样的感觉但不敢承认"的错误信号。</p>
<p>最佳的反应是：冷静、严肃、但保持善意。你可以说："谢谢你的坦诚，但我需要明确地告诉你，我爱我的妻子，我们的婚姻对我来说是最重要的。"</p>
<h2>第二步：第一时间告诉妻子</h2>
<p>这件事你绝对不能隐瞒。你可能担心告诉妻子会破坏她们的友谊，或者担心妻子会反应过激。但你要知道，如果妻子从其他渠道知道了这件事——而且她迟早会知道——而你没有主动告诉她，那信任的裂痕将难以修复。</p>
<p>告诉妻子的方式很重要。选择一个私密、放松的环境，用平静的语气陈述事实，不要添油加醋，也不要轻描淡写。同时表达你对婚姻的坚定态度，让她感到安心。</p>
<h2>第三步：明确切断暧昧通道</h2>
<p>在表白事件之后，你必须彻底切断和那个闺蜜的非必要联系。不再是"保持距离"，而是"断开联系"。这不是无情，而是对所有当事人最负责任的做法。任何模糊的处理都会给对方留下希望，也会让妻子持续不安。</p>
<h2>第四步：给妻子处理她们关系的空间</h2>
<p>至于妻子是否要和那个闺蜜继续做朋友，这是妻子自己的决定。你的角色是支持她，而不是替她做选择。你可以表达自己的担忧，但最终决定权在她。尊重她的选择，也是在尊重你们的婚姻。</p>`,
    category: '真实案例分享',
    categorySlug: 'zhen-shi-an-li-fen-xiang',
    author: '李心安',
    date: '2025-05-18',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20two%20people%20having%20a%20serious%20conversation%20with%20physical%20distance%20between%20them%2C%20one%20person%20gently%20but%20firmly%20setting%20a%20boundary%2C%20soft%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20style%2C%20respectful%20atmosphere&width=800&height=500&seq=article-confession-09&orientation=landscape',
    tags: ['表白', '危机处理', '婚姻保护'],
    readTime: 7
  },
  {
    id: 'article-10',
    slug: 'hun-yin-zhong-yi-xing-you-yi-ke-neng-ma',
    title: '婚姻中的异性友谊：可能吗？如何健康地存在？',
    excerpt: '结婚后还能有异性朋友吗？如果可以，什么样的异性友谊是健康的？本文从多角度探讨这个经久不衰的话题。',
    content: `<p>"结婚后还能有异性朋友吗？"这个问题在知乎上有超过一千万的浏览量。答案不是简单的"能"或"不能"，而是"取决于你怎么定义和经营这段友谊"。</p>
<h2>异性友谊的三个层次</h2>
<p><strong>第一层：熟人关系。</strong>你们认识，偶尔在聚会上聊天，微信上一年说不上十句话。这种关系在婚姻中完全无害，基本不需要任何特别的管理。</p>
<p><strong>第二层：普通朋友。</strong>你们有共同话题，偶尔会单独交流，但交流的内容和频率都在合理范围内。这种关系需要的是透明度——让配偶知道你们有交流，交流的内容是什么。</p>
<p><strong>第三层：亲密朋友。</strong>你们分享内心世界，有深度的情感连接。这在婚姻中是一个危险信号。婚后，最亲密的异性朋友应该是你的配偶。如果你的异性朋友占据了原本属于配偶的情感位置，那就是越界。</p>
<h2>健康异性友谊的四个标准</h2>
<p>第一，你的配偶知情且认可；第二，你们的互动完全经得起第三方的审视；第三，这段友谊不会占据你和配偶之间应有的情感空间；第四，你可以随时为了婚姻调整或停止这段友谊。</p>
<p>如果你发现自己对任何一个标准感到犹豫，那就说明这段友谊可能存在问题。</p>
<h2>妻子朋友的特殊性</h2>
<p>妻子的朋友处于一个特殊位置：她们天然地和你的婚姻有关联，但又是独立的个体。与她们建立健康的互动模式，核心在于"借妻为桥"——所有的善意和关心，都通过妻子的存在而传递和过滤。这样既保持了友好，也守住了边界。</p>`,
    category: '异性友谊处理',
    categorySlug: 'yi-xing-you-yi-chu-li',
    author: '张思齐',
    date: '2025-04-25',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20illustration%20of%20a%20group%20of%20friends%20including%20both%20men%20and%20women%20chatting%20in%20a%20bright%20park%20with%20natural%20boundaries%20visible%2C%20warm%20sunlight%2C%20soft%20beige%20and%20cream%20tones%2C%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=article-friendship-10&orientation=landscape',
    tags: ['异性友谊', '婚姻关系', '社交边界'],
    readTime: 7
  }
];

export const categories = [
  {
    name: '婚姻边界感',
    slug: 'hun-yin-bian-jie-gan',
    description: '探讨婚姻中边界感的本质与重要性，教你如何建立和维护健康的夫妻边界',
    icon: 'ri-shield-check-line',
    color: 'accent'
  },
  {
    name: '异性友谊处理',
    slug: 'yi-xing-you-yi-chu-li',
    description: '如何在婚后正确处理异性友谊，特别是与妻子朋友之间的相处之道',
    icon: 'ri-user-heart-line',
    color: 'primary'
  },
  {
    name: '社交场合行为',
    slug: 'she-jiao-chang-he-xing-wei',
    description: '聚会、聚餐、出游等社交场合中已婚男性应遵循的行为准则和礼仪',
    icon: 'ri-group-line',
    color: 'secondary'
  },
  {
    name: '夫妻沟通技巧',
    slug: 'fu-qi-gou-tong-ji-qiao',
    description: '提升夫妻沟通质量，学会在社交边界问题上进行开放而有效的对话',
    icon: 'ri-chat-heart-line',
    color: 'primary'
  },
  {
    name: '心理与情感',
    slug: 'xin-li-yu-qing-gan',
    description: '从心理学专业角度解读婚姻社交中的情感机制，提供科学的自我认知工具',
    icon: 'ri-psychotherapy-line',
    color: 'accent'
  },
  {
    name: '真实案例分享',
    slug: 'zhen-shi-an-li-fen-xiang',
    description: '来自读者的真实经历分享，在别人的故事中照见自己，汲取经验与教训',
    icon: 'ri-book-open-line',
    color: 'secondary'
  }
];